import { render } from "./ReportModal.vue?vue&type=template&id=5b3708d9&ts=true"
import script from "./ReportModal.vue?vue&type=script&lang=ts"
export * from "./ReportModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__